// provider/SentryUserProvider.tsx
'use client';

import { shouldEnableSentry } from '@/utils/common/environment';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import * as Sentry from '@sentry/nextjs';
import { useSession } from 'next-auth/react';
import { useLayoutEffect } from 'react';
export function SentryUserProvider({
  children
}: {
  readonly children: React.ReactNode;
}) {
  const {
    status
  } = useSession();
  const user = useCurrentUser();
  useLayoutEffect(() => {
    if (!shouldEnableSentry()) return;
    if (status === 'authenticated' && user?.id) {
      Sentry.setUser({
        id: user.id,
        email: user.email ?? undefined,
        username: user.name ?? undefined
      });
    } else if (status === 'unauthenticated') {
      Sentry.setUser(null);
    }
  }, [status, user]);
  return <>{children}</>;
}